import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import personalImg from "../assets/personal_loan.webp";
import housingImg from "../assets/housing_loan.webp";
import vehicleImg from "../assets/car_loan.webp";
import businessImg from "../assets/business_loan.webp";
import goldImg from "../assets/gold_loan.webp";
import lapImg from "../assets/loan_against_property.webp";
import icon1 from "../assets/icon1.png";
import icon2 from "../assets/icon2.png";
import icon3 from "../assets/icon3.png";
import icon4 from "../assets/icon4.png";
import icon5 from "../assets/icon5.png";
import icon6 from "../assets/icon6.png";
import { LazyImageComponent } from "../components/lazyloader/LazyImage";
import { Link } from "react-router-dom";

const loanTabs = [
  {
    key: "personal",
    title: "Personal Loan",
    iconImg: icon1,
    image: personalImg,
    heading: "Personal Loan",
    description:
      "Flexible loans designed to meet your personal needs with zero hassle.",
    subLoans: [
      {
        title: "Medical Loan",
        desc: "Cover unexpected medical expenses instantly.",
      },
      {
        title: "Education Loan",
        desc: "Fund higher studies in India or abroad.",
      },
      {
        title: "Marriage Loan",
        desc: "Make your special day memorable without financial stress.",
      },
      {
        title: "Travel Loan",
        desc: "Finance your holidays & explore the world worry-free.",
      },
    ],
  },
  {
    key: "housing",
    title: "Housing Loan",
    iconImg: icon2,
    image: housingImg,
    heading: "Housing Loan",
    description:
      "Affordable home loans with low-interest rates and quick approval.",
    subLoans: [
      { title: "Home Purchase Loan", desc: "Build your dream home easily." },
      {
        title: "Home Renovation",
        desc: "Upgrade or expand your home affordably.",
      },
      { title: "Balance Transfer Loan", desc: "Buy land for your future home." },
      { title: "Home Construction", desc: "Build your dream home easily." },
      {
        title: "Affordable housing Loan",
        desc: "Upgrade or expand your home affordably.",
      },
    ],
  },
  {
    key: "vehicle",
    title: "Vehicle Loan",
    iconImg: icon3,
    image: vehicleImg,
    heading: "Vehicle Loan",
    description:
      "Own your dream car or bike with easy EMIs and fast disbursal.",
    subLoans: [
      { title: "Car Loan", desc: "Buy new or pre-owned cars easily." },
      {
        title: "Two-Wheeler Loan",
        desc: "Ride your favorite bike with simple financing.",
      },
      {
        title: "Commercial Vehicle Loan",
        desc: "Ride your favorite bike with simple financing.",
      },
      {
        title: "Electric Vehicle Loan",
        desc: "Go green with affordable EV loans.",
      },
    ],
  },
  {
    key: "business",
    title: "Business Loan",
    iconImg: icon4,
    image: businessImg,
    heading: "Business Loan",
    description: "Grow your business with flexible and fast business loans.",
    subLoans: [
      { title: "SME/MSME Loan", desc: "Boost your small or medium enterprise." },
      {
        title: "Working Capital Loan",
        desc: "Turn your idea into a successful business.",
      },
      {
        title: "Team Loan",
        desc: "Keep your business running smoothly.",
      },
      { title: "Startup Loan", desc: "Boost your small or medium enterprise." },
      {
        title: "Machinery/Equipment Loan",
        desc: "Turn your idea into a successful business.",
      },
      {
        title: "Invoice Financing",
        desc: "Keep your business running smoothly.",
      },
      {
        title: "Overdraft Facility",
        desc: "Keep your business running smoothly.",
      },
    ],
  },
  {
    key: "gold",
    title: "Gold Loan",
    iconImg: icon5,
    image: goldImg,
    heading: "Gold Loan",
    description: "Instant cash by pledging your gold safely.",
    subLoans: [
      {
        title: "Regular Gold Loan",
        desc: "Get money quickly using your gold ornaments.",
      },
      { title: "Business Gold Loan", desc: "Repay easily within months." },
      {
        title: "Emergency Gold Loan",
        desc: "Get money quickly using your gold ornaments.",
      },
      { title: "Gold Loan Overdraft", desc: "Repay easily within months." },
      {
        title: "Gold Loan Top-up",
        desc: "Get money quickly using your gold ornaments.",
      },
    ],
  },
  {
    key: "lap",
    title: "Loan Against Property",
    iconImg: icon6,
    image: lapImg,
    heading: "Loan Against Property",
    description:
      "Unlock the value of your property with low-interest secured loans.",
    subLoans: [
      {
        title: "Commercial Property Loan",
        desc: "Use your business property to raise funds.",
      },
      {
        title: "Industrial Property Loan",
        desc: "Leverage your home for personal needs.",
      },
      {
        title: "Top-up LAP",
        desc: "Leverage your home for personal needs.",
      },
    ],
  },
];

export default function LoanTabsSection() {
  const [activeTab, setActiveTab] = useState("personal");
  const active = loanTabs.find((tab) => tab.key === activeTab);

  return (
    <div
      className="container-fluid py-5"
      style={{ overflow: "hidden", backgroundColor: "#f2f7ff" }}
    >
      <div className="row">
        <div className="col-10 mx-auto">
          <div className="text-center mb-4">
            <h2 className="fw-bold">Types of Service We Offer</h2>
            <p className="text-muted">Explore now</p>
          </div>

          {/* Tabs */}
          <div
            className="loan-tabs-container"
            style={{
              overflowX: "auto",
              whiteSpace: "nowrap",
            }}
          >
            <ul
              className="nav nav-tabs mb-4 w-100 flex-nowrap flex-md-wrap justify-content-md-center"
              style={{
                border: "none",
                display: "flex",
                justifyContent: "center",
                gap: "0",
                minWidth: "1000px",
              }}
            >
              {loanTabs.map((tab, index) => (
                <li
                  className="nav-item flex-fill"
                  key={tab.key}
                  style={{
                    textAlign: "center",
                    flex: "0 0 auto",
                    minWidth: "150px",
                  }}
                >
                  <button
                    className={`nav-link d-flex flex-column align-items-center justify-content-center py-4 ${
                      activeTab === tab.key ? "active" : ""
                    }`}
                    onClick={() => setActiveTab(tab.key)}
                    style={{
                      width: "100%",
                      border: "1px solid #fff",
                      borderRadius:
                        index === 0
                          ? "12px 0 0 12px"
                          : index === loanTabs.length - 1
                          ? "0 12px 12px 0"
                          : "0",
                      backgroundColor:
                        activeTab === tab.key ? "#fff" : "#2353A6",
                      color: activeTab === tab.key ? "#000" : "#fff",
                      fontWeight: "600",
                      fontSize: "16px",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <LazyImageComponent
                      src={tab.iconImg}
                      alt={tab.title}
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "contain",
                        marginBottom: "8px",
                      }}
                    />
                    <span>{tab.title}</span>
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="row align-items-start">
            <div className="col-md-4 p-0">
              <div className="position-relative h-100 mt-2 m-3">
                <LazyImageComponent
                  src={active.image}
                  alt={active.title}
                  className="w-100 border-0"
                  style={{
                    height: "100%",
                    objectFit: "cover",
                    minHeight: "320px",
                    maxHeight: "640px",
                    width: "100%",
                    borderRadius: "8px",
                  }}
                />
              </div>
            </div>

            <div className="col-md-8 d-flex flex-column justify-content-start p-0">
              <div className="card bg-white border-0 p-3 mb-4 rounded-3 mt-2">
                <h4 className="fw-bold mb-2">{active.heading}</h4>
                <p className="text-muted mb-4">{active.description}</p>
              </div>

              <div className="row g-4">
                {active.subLoans.map((item, idx) => (
                  <div key={idx} className="col-md-4">
                    <div className="p-4 border-0 bg-white rounded-3 h-100">
                      <h6 className="fw-bold fs-5">{item.title}</h6>
                      <p className="text-muted small fs-6">{item.desc}</p>
                      <Link
                        href="#"
                        className="text-primary fw-semibold text-decoration-none"
                      >
                        Apply Now →
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
